import styled, { keyframes } from 'styled-components/macro';

const DotAnimation1 = keyframes`
  0% {
   background-color: #2D67D8;
  }
  50% {
    background-color: #60A5F9;
  }
  100% {
    background-color: #BEDAFD;
  }
`;

const DotAnimation2 = keyframes`
  0% {
   background-color: #BEDAFD;
  }
  50% {
    background-color: #2D67D8;
  }
  100% {
    background-color: #60A5F9;
  }
`;

const DotAnimation3 = keyframes`
  0% {
   background-color: #2D67D8;
  }
  50% {
    background-color: #BEDAFD;
  }
  100% {
    background-color: #60A5F9;
  }
`;

export const Wrapper = styled.div`
  width: fit-content;
  background-color: #eef5fe;
  padding: 9px 12px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  border-radius: 8px 8px 8px 0;
`;

export const Dot = styled.div`
  width: 6px;
  height: 6px;
  border-radius: 6px;
  background-color: red;
  margin-right: 8px;

  &:nth-child(1) {
    animation: ${DotAnimation1} 1s linear infinite;
  }
  &:nth-child(2) {
    animation: ${DotAnimation2} 1s linear infinite;
  }
  &:nth-child(3) {
    animation: ${DotAnimation3} 1s linear infinite;
  }

  &:last-child {
    margin-right: 0;
  }
`;
